<template>
  <div class="pay-success__page">
    <div class="page-content">
      <div class="content">
        <div class="fail-icon">
          <i class="iconfont icon-zhifushibai"></i>
        </div>
        <div class="fail-content">
          <h2 class="title">充值失败！</h2>
          <h3 class="reason">失败原因：系统遇到问题了,我们正在全力解决</h3>
          <h3 class="reason">请联系客服！</h3>
          <div class="button-group">
            <router-link :to="{path: '/'}" tag="el-button" class="icon-fail">重新充值</router-link>
            <router-link :to="{path: '/'}" tag="el-button">返回</router-link>
          </div>
        </div>
      </div>
      <div class="questions">
        <h2 class="main-title">充值遇到问题：</h2>
        <div class="question">
          <p class="item">Q：充值到账时间？</p>
          <p class="answer">A：支付成功后，系统会在20秒内同步到账状态，如果5分钟以上没有同步，您可以将账户信息、支付时间以及支付截图发送给客服查询处理。</p>
        </div>
        <div class="question">
          <p class="item">Q：充值有没有限额，收不收手续费？</p>
          <p class="answer">A：系统本身没有限额，限额取决于银行对支付公司的限额，也取决于您的银行卡和您的网银版本（是U盾还是手机验证码网银）。目前系统充值不收取手续费。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.pay-success__page{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  
  .page-content{
    width: 80%;
    padding: 3% 10% 5%;
    background: #fff;
    border-radius: 7px;
    .content{
      display: flex;
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px dashed #ccc;
      .fail-icon{
        .iconfont{
          font-size: 60px;
          color: #FFAB1A;
        }
      }
      .fail-content{
        padding: 15px 0 35px 40px;
        .title{
          margin-bottom: 30px;
          height: 36px;
          line-height: 36px;
          font-size: 26px;
          color: #FFAB1A;
          letter-spacing: 3px;
        }
        .reason{
          margin-bottom: 15px;
          font-weight: 400;
        }
        .button-group{
          margin-top: 80px;
          .icon-fail{
            background-color: #FFAB1A;
            border-color: #FFAB1A;
            color: #fff;
            &:hover{
              opacity: .8;
            }
          }
        }
      }
    }
    .questions{
      margin-bottom: 30px;
      .main-title{
        height: 32px;
        line-height: 32px;
        font-size: 22px;
        letter-spacing: 2px;
        margin-bottom: 15px;
      }
      .question{
        margin-bottom: 20px;
        padding-left: 30px;
        padding-right: 15px;
        .item{
          margin-bottom: 5px;
          font-weight: 700;
          color: #525252;
        }
        .answer{
          color: #6e6e6e;
        }
      }
    }
  }
}

</style>





// WEBPACK FOOTER //
// src/views/recharge/fail.vue